import { render, staticRenderFns } from "./PlayNav.vue?vue&type=template&id=a3b3dab6&scoped=true"
import script from "./PlayNav.vue?vue&type=script&lang=js"
export * from "./PlayNav.vue?vue&type=script&lang=js"
import style0 from "./PlayNav.vue?vue&type=style&index=0&id=a3b3dab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b3dab6",
  null
  
)

export default component.exports